import React, { useState, useEffect, useContext } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import { useImmer } from 'use-immer';
import MUIDataTable from 'mui-datatables';
import { Box, IconButton, Tooltip } from '@material-ui/core';

import { 
    Add as AddIcon, 
    AddBox as AddBoxIcon, 
    BackspaceTwoTone as BackspaceTwoToneIcon, 
    VerifiedUserTwoTone as VerifiedUserTwoToneIcon,
    Edit as EditIcon, 
    Delete as DeleteIcon,
    DeleteForeverTwoTone as DeleteForeverTwoToneIcon
} from '@material-ui/icons';

import ResponsiveLayout from '../../Layouts/ResponsiveLayout';
import Toolbar from './Toolbar/Toolbar';
import ModalForm from './Modals/ModalForm';
import BackdropLoader from '../../../components/Shared/BackdropLoader/BackdropLoader';

import { StateContext, DispatchContext } from '../../../context/Provider';

const ManageSchools = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { globalState } = appState;
    const { globalDispatch } = appDispatch;

    const [open, setOpen] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState(null);

    const handleClick = (tableMeta) => {

        setSelectedSchool({
            id: tableMeta.rowData[0],
            school_name: tableMeta.rowData[1],
            email: tableMeta.rowData[2],
            school_address: tableMeta.rowData[3],
            contact_no: tableMeta.rowData[4],
            subdomain: tableMeta.rowData[5]
        });

        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const [options, setOptions] = useState({
        filter: true,
        filterType: 'dropdown',
        responsive: 'simple',
        rowsPerPage: 10,
        selectableRows: false, // turn off checkbox in rows
        customToolbar: () => {
            return (<Toolbar fetchSchools={fetchSchools} />);
        }
    });

    const [columns, setColumns] = useState([
        { label: "#", name: "id", options: { display: false } },
        { label: "Name", name: "name" },
        { label: "Email", name: "email" }, 
        { label: "Address", name: "address" }, 
        { label: "Contact #", name: "contact_no" }, 
        { label: "Subdomain", name: "subdomain" },
        { label: "Status", name: "is_active" },
        { label: 'Actions', name: "actions",
            options: { 
                customBodyRender: (value, tableMeta, updateValue) => {

                    let currentStatus = tableMeta.rowData[6];
                    let msg = 'Deactivate';
                    let actionIcon = (
                        <Tooltip title="Deactivate">
                            <BackspaceTwoToneIcon fontSize="small" />
                        </Tooltip>
                    );

                    if (currentStatus == 'Inactive') {
                        msg = 'Activate';
                        actionIcon = (
                            <Tooltip title="Activate">
                                <VerifiedUserTwoToneIcon fontSize="small" />
                            </Tooltip>
                        );
                    }

                    return (
                        <>
                            <IconButton 
                                aria-label="edit" 
                                onClick={() => handleClick(tableMeta)}>
                                <Tooltip title="Edit">
                                    <EditIcon fontSize="small" />
                                </Tooltip>
                            </IconButton>
                            <IconButton 
                                aria-label="delete" 
                                onClick={() => { 
                                    window.confirm(`Are you sure you want to ${msg} this item?`) && removeItem(tableMeta) 
                                }}>
                                {actionIcon}
                            </IconButton>
                        </>
                    )
                }
            }
        }
    ]);
 
    const [state, setState] = useImmer({
        isLoading: false,
        schools: []
    });

    async function fetchSchools() {
        try {
            const response = await axiosConfig.get(`/schools`); 
            const { data } = response.data;

            const schoolsArr = [];
            data.map(function (data, index) {

                data.is_active = data.is_active == 1 ? 'Active' : 'Inactive'; 
                schoolsArr.push({
                    id: data.id,
                    name: data.name,
                    email: data.email,
                    address: data.address,
                    contact_no: data.contact_no,
                    subdomain: data.subdomain,
                    is_active: data.is_active,
                });

                // data.is_active = data.is_active == 1 ? 'Active' : 'Inactive'; 
                // setState(draft => {
                //     draft.schools.push({
                //         id: data.id,
                //         name: data.name,
                //         email: data.email,
                //         address: data.address,
                //         contact_no: data.contact_no,
                //         subdomain: data.subdomain,
                //         is_active: data.is_active,
                //     });
                // });
            });

            globalDispatch({type: "setSchools", value: schoolsArr});
        
        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    async function removeItem(tableMeta) {
        globalDispatch({type: 'setIsLoading', value: true});
        const schoolID = tableMeta.rowData[0];
        console.log(schoolID);

        try {
            const response = await axiosConfig.post(`/schools/${schoolID}`, {
                _method: "DELETE"
            }); 

            const { status_code, message } = response.data;

            if (status_code == 'ok') {
                console.log(message);
                fetchSchools();
            }

        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        
        globalDispatch({type: 'setIsLoading', value: true});
        const source = axiosConfig.CancelToken.source();

        fetchSchools();

        return () => {
            source.cancel();
        }

    }, []);
      
    return (
        <ResponsiveLayout>
            <ModalForm
                open={open}
                handleClose={handleClose}
                fetchSchools={fetchSchools}
                selectedSchool={selectedSchool}
            />

            { state.isLoading 
                ?   <BackdropLoader isLoading={true} />
                :   <MUIDataTable 
                        title={"List of Schools"} 
                        data={globalState.schools} 
                        columns={columns} 
                        options={options} 
                    />
            }
        </ResponsiveLayout>
    );
}

export default ManageSchools;